export class MensajeUsuario {
    constructor (
        public readonly Id: number,
        public readonly FechaCreacion: Date,
        public readonly FechaEnvio: Date | null,
        public readonly FechaEnvioHora: number | null,
        public readonly FechaEnvioMinuto: number | null,
        public readonly UsuarioCreadorId: number | null,
        public readonly UsuarioCreadorNombre: string | null,
        public readonly UsuarioCreadorApellido: string | null,
        public readonly UsuarioCreadorLogin: string | null,
        public readonly UsuarioDestinoNombre: string | null,
        public readonly UsuarioDestinoApellido: string | null,
        public readonly UsuarioDestinoLogin: string | null,
        public readonly EnvioId: string | null,
        public readonly Asunto: string | null,
        public readonly Mensaje: string | null,
        public readonly Leido: boolean,
        public readonly Editable: boolean,
        public readonly OpcionEnvioId: number | null,
        public readonly MensajeUsuarioTipoId: number | null,
        public readonly RolDestinoId: number | null,
        public readonly UsuarioDestinoId: number | null,
        public readonly TotalEnviados: number,
        public Adjuntos: MensajeUsuarioAdjunto[],
        public MensajeHtml: any
    ) {}
}

export class MensajeUsuarioAdjunto {
    constructor (
        public readonly Id: number,
        public readonly NombreDocumento: string | null,
        public readonly UrlDocumento: string | null,
        public readonly MensajeUsuarioId: number,
        public readonly IncluidoEnCuerpoMensaje: boolean
    ) {}
}

export class CantidadNoLeidosUsuarioDto {
    constructor (
        public readonly Total: number
    ) {}
}

export class SearchMensajeUsuarioRequestDto {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly VerEnviados: boolean | null,
        public readonly FechaCreacionDesde: Date | null,
        public readonly FechaCreacionHasta: Date | null,
        public readonly FechaEnvioDesde: Date | null,
        public readonly FechaEnvioHasta: Date | null,
        public readonly MensajeUsuarioTipoId: number | null,
        public readonly UsuarioCreador: string | null,
        public readonly UsuarioDestino: string | null,
        public readonly Asunto: string | null,
        public readonly VerSoloNoLeidos: boolean | null
    ){}
}

export class SearchMensajeUsuarioResponseDto {
    constructor(
        public readonly count: number,
        public readonly result: SearchMensajeUsuarioItemDto[]
    ){}
}

export class SearchMensajeUsuarioItemDto {
    constructor(
        public readonly Id: number,
        public readonly UsuarioCreadorId: number,
        public readonly UsuarioCreadorNombre: string | null,
        public readonly UsuarioCreadorLogin: string | null,
        public readonly UsuarioDestinoNombre: string | null,
        public readonly UsuarioDestinoLogin: string | null,
        public readonly UsuarioNombre: string | null,
        public readonly UsuarioLogin: string | null,
        public readonly Asunto: string | null,
        public readonly MensajeUsuarioTipoCodigo: string | null,
        public readonly MensajeUsuarioTipoNombre: string | null,
        public readonly FechaCreacion: Date,
        public readonly FechaEnvio: Date,
        public readonly Leido: boolean,
        public readonly Enviado: boolean,
        public readonly FechaLeido: Date | null,
        public readonly EsPopUp: boolean
    ){}
}

export class MensajeUsuarioResumenDto {
    constructor(
        public readonly Id: number,
        public readonly UsuarioCreadorNombre: string | null,
        public readonly UsuarioCreadorImagenUrl: string | null,
        public readonly Asunto: string | null,
        public readonly FechaEnvio: Date,
        public readonly Leido: boolean,
        public readonly EsPopUp: boolean
    ){}
}

export class SaveMensajeUsuario {
    constructor (
        public readonly Id: number | null,
        public readonly FechaEnvio: Date | null,
        public readonly HoraEnvioString: string | null,
        public readonly RolDestinoId: number | null,
        public readonly ComunidadDestinoId: number | null,
        public readonly UsuarioDestinoId: number | null,
        public readonly MensajeUsuarioTipoId: number | null,
        public readonly Asunto: string | null,
        public readonly Mensaje: string | null,
        public readonly OpcionEnvioId: number | null,
        public readonly NotificarUsuariosEmail: boolean,
        public Adjuntos: MensajeUsuarioAdjunto[],
        public NuevosAdjuntosBorrados: string[]
    ) {}
}

export class UploadMensajeUsuarioAttachResponseDto {
    constructor (
        public readonly Archivos: MensajeUsuarioAdjunto[]
    ) {}
}

export class SendMensajeUsuarioNotificationDto {
    constructor (
        public readonly mensajeUsuarioId: number,
        public readonly usuarioDestinoId: number,
        public readonly usuarioOrigen: string | null,
        public readonly asunto: string
    ) {}
}
